/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-10 00:22:39
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-09-18 10:30:46
 * @FilePath: /unifyxp-v2-store-portal/src/components/Layouts/Section/SectionWrapper.tsx
 */
import React from 'react';
import css from './SectionWrapper.less';
import { ErrorBoundary } from 'src/components/ErrorBoundary';

const Wrapper = (props) => {
  const {
    title,
    children,
    rightPart,
    subtitle,
    //height,
    hideContent,
    noPadding,
    style,
    hideTitle,
    className,
    containerClassName,
    titleClassName,
    isHeader,
    id,
    titleOnClick,
  } = props;
  return (
    <div
      className={`${css.wrapper} ${className || ''}`}
      {...(id ? { id } : {})}>
      {!hideTitle && (
        <div
          className={`${
            isHeader ? css.titleHeaderContainer : css.titleContainer
          } ${titleClassName || ''}`}
          onClick={titleOnClick}>
          <div className={css.title}>
            <span className={css.titleSpan}>{title || ''}</span>
            {subtitle ? <div className={css.subtitle}>{subtitle}</div> : <></>}
          </div>
          {rightPart && <div className={css.switchContainer}>{rightPart}</div>}
        </div>
      )}

      {!hideContent && (
        <div
          className={`${css.contentContainer} ${containerClassName || ''}`}
          {...(style ? { style } : {})}
          {...(noPadding && { style: { padding: 0 } })}>
          <ErrorBoundary>{children}</ErrorBoundary>
        </div>
      )}
    </div>
  );
};
export default Wrapper;

const SectionWrapper = (props) => {
  const { containerClassName, children, ...rest } = props;
  return (
    <Wrapper
      containerClassName={`${css.containerClassName} ${
        containerClassName || ''
      }`}
      {...rest}>
      {children}
    </Wrapper>
  );
};
export { SectionWrapper };
